import * as React from "react";

import { AccountShape } from "@eave/shared/types/api";
import DocDisplay from "../../shared/DocDisplay";
import { acctToTitleStr } from "./shared";

const { Button, Modal } = require("react-bootstrap");

interface DocsForAccountProps {
  account: AccountShape;
  docs: any;
  onHide: Function;
}

export default class DocsForAccount extends React.Component<DocsForAccountProps, any> {
  render() {
    const { account, docs, onHide } = this.props;

    return (
      <Modal bsSize="large" show animation={false} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Documents for {acctToTitleStr(account)}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="docs-for-acct__modal-body">
          <div className="docs-for-acct__container">
            <DocDisplay docs={docs} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsSize="small" onClick={onHide}>
            <i className="fa fa-thumbs-up" /> OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
